module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-create-service-link.34dc1013.png";